/**
 * Conditionally pushes focus options into an array of parameters to be applied to
 * `HTMLElement.prototype.focus()`, if scrolling is prevented in configuration.
 */

const prepareNativeFocusParameters = (shouldPreventScroll: boolean): Parameters<HTMLOrSVGElement['focus']> => {
    const focusParameters: Parameters<HTMLOrSVGElement['focus']> = [];

    if (shouldPreventScroll) {
        focusParameters.push({
            preventScroll: true,
        });
    }

    return focusParameters;
};

export default prepareNativeFocusParameters;
